import rest from '@/js/rest'

export const getUrlSearch = (name) => {
  // 未传参，返回空
  if (!name) return null
  // 查询参数：先通过search取值，如果取不到就通过hash来取
  var after = window.location.search
  after = after.substr(1) || window.location.hash.split('?')[1]
  // 地址栏URL没有查询参数，返回空
  if (!after) return null
  // 如果查询参数中没有"name"，返回空
  if (after.indexOf(name) === -1) return null

  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  // 当地址栏参数存在中文时，需要解码，不然会乱码
  var r = decodeURI(after).match(reg)
  // 如果url中"name"没有值，返回空
  if (!r) return null

  return r[2]
}
// 设置headers的code值
export const setCodeToHeaders = (value) => {
  if (value) {
    rest.client.defaults.headers.code = value
  }
}

// 清除所有空格
export const removeAllSpace = (value) => {
  if (value) {
    return value.replace(/\s+/g, '')
  } else {
    return value
  }
}

// 是否为空判断
export const isEmpty = (value) => {
  let v = removeAllSpace(value)
  if (v) {
    return false
  } else {
    return true
  }
}

// 判断是否为手机号
export const isMobileNum = (tel) => {
  let t = removeAllSpace(tel)
  let regTel = /^[1][3-9][0-9]{9}$/
  if (t) {
    if (regTel.test(t)) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

// 长度不小于?位
export const notLessThanLength = (value, num) => {
  let v = removeAllSpace(value)
  if (v) {
    // console.log(v.length)
    if (v.length < num) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

// 输入框正则校验
export const regExpInp = (value, regExp) => {
  let v = removeAllSpace(value)
  if (regExp.test(v)) {
    return true
  } else {
    return false
  }
}
// 密码校验
export const isValidPassword = (value) => {
  let v = removeAllSpace(value) // 移除所有空格
  if (!v) {
    return true // 密码为空，校验不通过
  }

  // 正则：8-16位，必须同时包含字母和数字
  const reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/

  if (reg.test(v)) {
    return false // 校验通过
  } else {
    return true // 校验不通过
  }
}
